import * as fromDatatype from '../datatype-library/index';

export interface bl_crm_address_book_contact_record_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    firstname: fromDatatype.VarcharDatatypeInterface;
    lastname: fromDatatype.VarcharDatatypeInterface;
    custom_fields_json: fromDatatype.JsonDatatypeInterface;
    job_title: fromDatatype.VarcharDatatypeInterface;
    dob: fromDatatype.TimestampTzDatatypeInterface;
    title: fromDatatype.VarcharDatatypeInterface;
    description: fromDatatype.VarcharDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_crm_address_book_contact_record_hdr_RowClass implements bl_crm_address_book_contact_record_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    firstname: fromDatatype.VarcharDatatypeInterface;
    lastname: fromDatatype.VarcharDatatypeInterface;
    custom_fields_json: fromDatatype.JsonDatatypeInterface;
    job_title: fromDatatype.VarcharDatatypeInterface;
    dob: fromDatatype.TimestampTzDatatypeInterface;
    title: fromDatatype.VarcharDatatypeInterface;
    description: fromDatatype.VarcharDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
}
